/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, volume: NonNullable<unknown> }} Progress_Extra_Calendar_DayInputs */

const en_us2_progress_extra_calendar_day = /** @type {(inputs: Progress_Extra_Calendar_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: ${i?.volume}`)
};

const pt_br2_progress_extra_calendar_day = /** @type {(inputs: Progress_Extra_Calendar_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: ${i?.volume}`)
};

const es_419_progress_extra_calendar_day = /** @type {(inputs: Progress_Extra_Calendar_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: ${i?.volume}`)
};

const pt_pt2_progress_extra_calendar_day = /** @type {(inputs: Progress_Extra_Calendar_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: ${i?.volume}`)
};

const fr_fr2_progress_extra_calendar_day = /** @type {(inputs: Progress_Extra_Calendar_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} : ${i?.volume}`)
};

const de_de2_progress_extra_calendar_day = /** @type {(inputs: Progress_Extra_Calendar_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: ${i?.volume}`)
};

const it_it2_progress_extra_calendar_day = /** @type {(inputs: Progress_Extra_Calendar_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: ${i?.volume}`)
};

/**
* | output |
* | --- |
* | "{day}: {volume}" |
*
* @param {Progress_Extra_Calendar_DayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_calendar_day = /** @type {((inputs: Progress_Extra_Calendar_DayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Calendar_DayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_calendar_day(inputs)
	if (locale === "es-419") return es_419_progress_extra_calendar_day(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_calendar_day(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_calendar_day(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_calendar_day(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_calendar_day(inputs)
	return en_us2_progress_extra_calendar_day(inputs)
});
export { progress_extra_calendar_day as "progress-extra.calendar_day" }